import { Pipe, PipeTransform } from '@angular/core';
import { Step } from '../components/dialog/issue-transaction-dialog2/issue-transaction-dialog2-component-classes';

@Pipe({
  name: 'visibleSteps'
})
export class VisibleStepsPipe implements PipeTransform {

  transform(steps: Step[]): Step[] {
    return Array.isArray(steps)? steps.filter(x => !x.isHidden): [];
  }

}
